"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageFeeCollector__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address payable",
                name: "_requestBurnerContract",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "burnerAddress",
                type: "address",
            },
        ],
        name: "UpdatedBurnerContract",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "minimumFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rateFeesNumerator",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rateFeesDenominator",
                type: "uint256",
            },
        ],
        name: "UpdatedFeeParameters",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "threshold",
                type: "uint256",
            },
        ],
        name: "UpdatedMinimumFeeThreshold",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "WhitelistAdminAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "WhitelistAdminRemoved",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "addWhitelistAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_contentSize",
                type: "uint256",
            },
        ],
        name: "getFeesAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "isWhitelistAdmin",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minimumFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rateFeesDenominator",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rateFeesNumerator",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceWhitelistAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "requestBurnerContract",
        outputs: [
            {
                internalType: "address payable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_minimumFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_rateFeesNumerator",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_rateFeesDenominator",
                type: "uint256",
            },
        ],
        name: "setFeeParameters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "_requestBurnerContract",
                type: "address",
            },
        ],
        name: "setRequestBurnerContract",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x60806040523480156200001157600080fd5b50604051620011db380380620011db8339818101604052810190620000379190620002f0565b620000576200004b6200009f60201b60201c565b620000a760201b60201c565b80600460006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550506200043d565b600033905090565b620000c28160006200010860201b6200047d1790919060201c565b8073ffffffffffffffffffffffffffffffffffffffff167f22380c05984257a1cb900161c713dd71d39e74820f1aea43bd3f1bdd2096129960405160405180910390a250565b6200011a8282620001bb60201b60201c565b156200015d576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401620001549062000383565b60405180910390fd5b60018260000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055505050565b60008073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff1614156200022f576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040162000226906200041b565b60405180910390fd5b8260000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16905092915050565b600080fd5b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b6000620002b8826200028b565b9050919050565b620002ca81620002ab565b8114620002d657600080fd5b50565b600081519050620002ea81620002bf565b92915050565b60006020828403121562000309576200030862000286565b5b60006200031984828501620002d9565b91505092915050565b600082825260208201905092915050565b7f526f6c65733a206163636f756e7420616c72656164792068617320726f6c6500600082015250565b60006200036b601f8362000322565b9150620003788262000333565b602082019050919050565b600060208201905081810360008301526200039e816200035c565b9050919050565b7f526f6c65733a206163636f756e7420697320746865207a65726f20616464726560008201527f7373000000000000000000000000000000000000000000000000000000000000602082015250565b60006200040360228362000322565b91506200041082620003a5565b604082019050919050565b600060208201905081810360008301526200043681620003f4565b9050919050565b610d8e806200044d6000396000f3fe608060405234801561001057600080fd5b506004361061009e5760003560e01c806375c268f31161006657806375c268f3146101215780638f5b87e11461013f578063bb5f747b1461016f578063cb2537cb1461019f578063e40e8457146101bb5761009e565b80631a7626e7146100a3578063263f6a42146100c15780634c5a628c146100df578063524eb29c146100e95780637362d9c814610105575b600080fd5b6100ab6101d9565b6040516100b89190610769565b60405180910390f35b6100c96101df565b6040516100d69190610769565b60405180910390f35b6100e76101e5565b005b61010360048036038101906100fe91906107e7565b6101f7565b005b61011f600480360381019061011a9190610852565b6102e3565b005b61012961033e565b6040516101369190610769565b60405180910390f35b610159600480360381019061015491906108ab565b610344565b6040516101669190610769565b60405180910390f35b61018960048036038101906101849190610852565b610390565b60405161019691906108f3565b60405180910390f35b6101b960048036038101906101b4919061090e565b6103ad565b005b6101c3610457565b6040516101d09190610970565b60405180910390f35b60015481565b60025481565b6101f56101f0610525565b61052d565b565b610207610202610525565b610390565b610246576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161023d90610a0e565b60405180910390fd5b80600460006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055507fb2c87fdcc342ca09b09df1fb16a153b7ceb0a4b56ad223f12c8fbff63f98ccd8600460009054906101000a900473ffffffffffffffffffffffffffffffffffffffff166040516102d89190610a8d565b60405180910390a150565b6102f36102ee610525565b610390565b610332576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161032990610a0e565b60405180910390fd5b61033b81610587565b50565b60035481565b600080600254836103559190610ad7565b9050600060035414610372576003548161036f9190610b60565b90505b60015481116103865760015491505061038b565b809150505b919050565b60006103a68260006105e190919063ffffffff16565b9050919050565b6103bd6103b8610525565b610390565b6103fc576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016103f390610a0e565b60405180910390fd5b8260018190555081600281905550806003819055507f741cafcfc8058975fab7ed6bdaf402b47dca8aa9826990c454c058a6f9b06d1660015460025460035460405161044a93929190610b91565b60405180910390a1505050565b600460009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b61048782826105e1565b156104c7576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016104be90610c14565b60405180910390fd5b60018260000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055505050565b600033905090565b6105418160006106a990919063ffffffff16565b8073ffffffffffffffffffffffffffffffffffffffff167f0a8eb35e5ca14b3d6f28e4abf2f128dbab231a58b56e89beb5d636115001e16560405160405180910390a250565b61059b81600061047d90919063ffffffff16565b8073ffffffffffffffffffffffffffffffffffffffff167f22380c05984257a1cb900161c713dd71d39e74820f1aea43bd3f1bdd2096129960405160405180910390a250565b60008073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff161415610652576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161064990610ca6565b60405180910390fd5b8260000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16905092915050565b6106b382826105e1565b6106f2576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016106e990610d38565b60405180910390fd5b60008260000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055505050565b6000819050919050565b61076381610750565b82525050565b600060208201905061077e600083018461075a565b92915050565b600080fd5b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b60006107b482610789565b9050919050565b6107c4816107a9565b81146107cf57600080fd5b50565b6000813590506107e1816107bb565b92915050565b6000602082840312156107fd576107fc610784565b5b600061080b848285016107d2565b91505092915050565b600061081f82610789565b9050919050565b61082f81610814565b811461083a57600080fd5b50565b60008135905061084c81610826565b92915050565b60006020828403121561086857610867610784565b5b60006108768482850161083d565b91505092915050565b61088881610750565b811461089357600080fd5b50565b6000813590506108a58161087f565b92915050565b6000602082840312156108c1576108c0610784565b5b60006108cf84828501610896565b91505092915050565b60008115159050919050565b6108ed816108d8565b82525050565b600060208201905061090860008301846108e4565b92915050565b60008060006060848603121561092757610926610784565b5b600061093586828701610896565b935050602061094686828701610896565b925050604061095786828701610896565b9150509250925092565b61096a816107a9565b82525050565b60006020820190506109856000830184610961565b92915050565b600082825260208201905092915050565b7f57686974656c69737441646d696e526f6c653a2063616c6c657220646f65732060008201527f6e6f742068617665207468652057686974656c69737441646d696e20726f6c65602082015250565b60006109f860408361098b565b9150610a038261099c565b604082019050919050565b60006020820190508181036000830152610a27816109eb565b9050919050565b6000819050919050565b6000610a53610a4e610a4984610789565b610a2e565b610789565b9050919050565b6000610a6582610a38565b9050919050565b6000610a7782610a5a565b9050919050565b610a8781610a6c565b82525050565b6000602082019050610aa26000830184610a7e565b92915050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b6000610ae282610750565b9150610aed83610750565b9250817fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0483118215151615610b2657610b25610aa8565b5b828202905092915050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b6000610b6b82610750565b9150610b7683610750565b925082610b8657610b85610b31565b5b828204905092915050565b6000606082019050610ba6600083018661075a565b610bb3602083018561075a565b610bc0604083018461075a565b949350505050565b7f526f6c65733a206163636f756e7420616c72656164792068617320726f6c6500600082015250565b6000610bfe601f8361098b565b9150610c0982610bc8565b602082019050919050565b60006020820190508181036000830152610c2d81610bf1565b9050919050565b7f526f6c65733a206163636f756e7420697320746865207a65726f20616464726560008201527f7373000000000000000000000000000000000000000000000000000000000000602082015250565b6000610c9060228361098b565b9150610c9b82610c34565b604082019050919050565b60006020820190508181036000830152610cbf81610c83565b9050919050565b7f526f6c65733a206163636f756e7420646f6573206e6f74206861766520726f6c60008201527f6500000000000000000000000000000000000000000000000000000000000000602082015250565b6000610d2260218361098b565b9150610d2d82610cc6565b604082019050919050565b60006020820190508181036000830152610d5181610d15565b905091905056fea264697066735822122087b0ecedb5be2508d530c8003618a4390942f07c57425ecc18f84bde5990c65064736f6c63430008090033";
class StorageFeeCollector__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(_requestBurnerContract, overrides) {
        return super.deploy(_requestBurnerContract, overrides || {});
    }
    getDeployTransaction(_requestBurnerContract, overrides) {
        return super.getDeployTransaction(_requestBurnerContract, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.StorageFeeCollector__factory = StorageFeeCollector__factory;
StorageFeeCollector__factory.bytecode = _bytecode;
StorageFeeCollector__factory.abi = _abi;
